import React from "react";
import { ESTADO_LABELS, ESTADO_TONES, ORIGEN_LABELS, codeOf, labelFor } from "../rolloFormat";

// PriorityChip and LateTag moved to the shared components; re-exported so Rollo keeps importing them from here.
export { LateTag, PriorityChip } from "../../crmpostventa-shared/components/Chips";

// StatusChip: rounded chip with a dot. The word is always written, color is never the only signal.
export function StatusChip({ estado }) {
  const tone = ESTADO_TONES[codeOf(estado)] || "cancelled";
  return (
    <span className={`crm-rollo__chip crm-rollo__chip--status crm-rollo__chip--${tone}`}>{labelFor(ESTADO_LABELS, estado)}</span>
  );
}

export function OrigenChip({ origen }) {
  return <span className="crm-rollo__chip crm-rollo__chip--origen">{labelFor(ORIGEN_LABELS, origen)}</span>;
}
